/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes = [];

// Search Debug (must be before /search to match first)
childRoutes[childRoutes.length] = {
    path: '/search/debug',
    exact: true,
    componentName: 'SearchDebugPage',
    title: 'Search Debug',
};

// Search
childRoutes[childRoutes.length] = {
    path: '/search',
    exact: true,
    componentName: 'SearchResultsPage',
    title: 'Search Results',
};

export default childRoutes;
